"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductAudience = exports.getMinimumOpeningDeposit = exports.getMonthlyFeeSubCopy = exports.getSubProductType = exports.getStarRatingTooltip = exports.getStarRating = exports.getSlug = exports.getIsMonetizing = exports.getMonetizationStatus = exports.shouldMonetize = exports.couldMonetize = exports.getRatingOverdraftFee = exports.getRatingInstitution = exports.getRatingBankExperience = exports.getProsBullets = exports.getProductName = exports.getOutOfNetworkATMFee = exports.getOfferUrl = exports.getName = exports.getMonthlyFee = exports.getMinimumBalance = exports.getInstitutionType = exports.getLegacyInstitutionType = exports.getLearnMoreLink = exports.getIssuerName = exports.getImageSrc = exports.getImageAltText = exports.getFederallyInsuredAnnotation = exports.getFederallyInsured = exports.getDisplayStatus = exports.getDisplayPages = exports.getDirectDepositWaive = exports.getConsBullets = exports.getBottomLineOverdraftFee = exports.getBottomLineInstitution = exports.getBottomLineBankExperience = exports.getBottomLine = exports.getBonusDetails = exports.getBonusAmount = exports.getBalanceToAvoidFees = exports.getAPYAnnotation = exports.getAPY = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _logging = require("@nerdwallet/logging");

var _constants = require("../constants");

var _utils = require("../utils");

var _deprecation = require("../utils/deprecation");

var _generalUtils = require("./common/general-utils");

var _FDIC_TYPE_ANNOTATION;

var withDeprecationWarning = (0, _deprecation.makeModuleDeprecationDecorator)('banking');
var logger = (0, _logging.getLogger)('@nerdwallet/marketplace/selectors/banking');
/**
 * Gets annual percentage yield.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {string}                     The annual percentage yield.
 */

var getAPY = function getAPY(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'derived_details.display_apy.value');
};
/**
 * Gets APY annotation text.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {string}                     The APY annotation text.
 */


exports.getAPY = getAPY;

var getAPYAnnotation = function getAPYAnnotation(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.apy_annotation.value');
};
/**
 * Gets minimum balance needed to avoid fees.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {number}                     The minimum balance needed to avoid fees.
 */


exports.getAPYAnnotation = getAPYAnnotation;

var getBalanceToAvoidFees = function getBalanceToAvoidFees(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.balance_to_avoid_fees.value');
};
/**
 * Gets bonus amount received for opening an account.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {number}                     The bonus amount received.
 */


exports.getBalanceToAvoidFees = getBalanceToAvoidFees;

var getBonusAmount = function getBonusAmount(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.bonus_amount.value');
};
/**
 * Gets details about the bonus terms and conditions.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {number}                     The bonus details.
 */


exports.getBonusAmount = getBonusAmount;

var getBonusDetails = function getBonusDetails(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.bonus_details.value');
};
/**
 * Get bottom line content.
 * @note expects augmentation via `banking-products` post type through
 * AdditionalDataSDK.
 * Fallback to `getBottomLineInstitution`.
 *
 * @param  {Object} marketplaceEntity     The (banking-products augmented) BNK entity
 *
 * @return {Object|String}             "Bottom line" Structured Content or text
 */


exports.getBonusDetails = getBonusDetails;

var getBottomLine = function getBottomLine(marketplaceEntity) {
  var fallbackBottomLine = getBottomLineInstitution(marketplaceEntity);
  return (0, _get2.default)((0, _utils.getAdditionalData)((0, _generalUtils.getProduct)(marketplaceEntity)), 'summary', fallbackBottomLine);
};
/**
 * Get bottom line content on "Bank experience".
 * @note expects augmentation via `banking-institutions` post type through
 * AdditionalDataSDK
 *
 * @param {Object}  marketplaceEntity  The BNK entity.
 *
 * @return {Object}                   "Bank experience bottom line" Structured Content
 */


exports.getBottomLine = getBottomLine;

var getBottomLineBankExperience = function getBottomLineBankExperience(marketplaceEntity) {
  return (0, _get2.default)((0, _utils.getAdditionalData)((0, _generalUtils.getInstitution)(marketplaceEntity)), 'bank_experience_summary');
};
/**
 * Get bottom line content for the institution.
 * @note expects augmentation via `banking-institutions` post type through
 * AdditionalDataSDK
 * Fallback to deprecated field set by banking-products service.
 *
 * @param {Object}  marketplaceEntity  The BNK entity.
 *
 * @return {Object|String}          "Institution bottom line" Structured Content or text
 */


exports.getBottomLineBankExperience = getBottomLineBankExperience;

var getBottomLineInstitution = function getBottomLineInstitution(marketplaceEntity) {
  var fallbackBottomLine = (0, _get2.default)(marketplaceEntity, 'review');
  return (0, _get2.default)((0, _utils.getAdditionalData)((0, _generalUtils.getInstitution)(marketplaceEntity)), 'summary', fallbackBottomLine);
};
/**
 * Get bottom line content on "Overdraft fee".
 * @note expects augmentation via `banking-institutions` post type through
 * AdditionalDataSDK
 *
 * @param {Object}  marketplaceEntity  The BNK entity.
 *
 * @return {Object}                    "Overdraft fee bottom line" Structured Content
 */


exports.getBottomLineInstitution = getBottomLineInstitution;

var getBottomLineOverdraftFee = function getBottomLineOverdraftFee(marketplaceEntity) {
  return (0, _get2.default)((0, _utils.getAdditionalData)((0, _generalUtils.getInstitution)(marketplaceEntity)), 'overdraft_fee_summary');
};
/**
 * Get the "cons" bullets for an offer.
 * @note expects augmentation via `banking-products` post type through
 * AdditionalDataSDK
 *
 * @param   {Object} marketplaceEntity  The BNK entity.
 * @return  {Array<Object>} - The "cons" Structured Content array
 */


exports.getBottomLineOverdraftFee = getBottomLineOverdraftFee;

var getConsBullets = function getConsBullets(marketplaceEntity) {
  return (0, _get2.default)((0, _utils.getAdditionalData)((0, _generalUtils.getProduct)(marketplaceEntity)), 'cons');
};
/**
 * Gets direct deposit needed to avoid fees.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {number}                     The value of a direct deposit needed to avoid fees.
 */


exports.getConsBullets = getConsBullets;

var getDirectDepositWaive = function getDirectDepositWaive(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.direct_deposit_waive.value');
};
/**
 * Gets display pages of a marketplaceEntity
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {Array}                      The array of display pages
 */


exports.getDirectDepositWaive = getDirectDepositWaive;

var getDisplayPages = function getDisplayPages(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.display_pages.value', []);
};
/**
 * Gets display status of a marketplaceEntity
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {string}                     The status [ACTIVE,INACTIVE]
 */


exports.getDisplayPages = getDisplayPages;

var getDisplayStatus = function getDisplayStatus(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.display_status.value');
};
/**
 * Gets agency name that federally insures the entity's institution.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {string}                     The agency name that federally insures
 *                                          the entity's institution.
 */


exports.getDisplayStatus = getDisplayStatus;

var getFederallyInsured = function getFederallyInsured(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.federally_insured.value');
};

exports.getFederallyInsured = getFederallyInsured;
var FDIC_TYPE_ANNOTATIONS = (_FDIC_TYPE_ANNOTATION = {}, (0, _defineProperty2.default)(_FDIC_TYPE_ANNOTATION, _constants.FEDERALLY_INSURED_TYPES.FDIC, _constants.FDIC_ANNOTATION), (0, _defineProperty2.default)(_FDIC_TYPE_ANNOTATION, _constants.FEDERALLY_INSURED_TYPES.NCUA, _constants.NCUA_ANNOTATION), (0, _defineProperty2.default)(_FDIC_TYPE_ANNOTATION, _constants.FEDERALLY_INSURED_TYPES.NON_MEMBER_FDIC, _constants.NON_MEMBER_FDIC_ANNOTATION), _FDIC_TYPE_ANNOTATION);
/**
 * Get annotation for the agency that federally insures the institution.
 *
 * @param {Object} marketplaceEntity The BNK entity.
 * @return {string} The annotation to be displayed about the insuring agency.
 */

var getFederallyInsuredAnnotation = function getFederallyInsuredAnnotation(marketplaceEntity) {
  var federallyInsured = getFederallyInsured(marketplaceEntity);
  return FDIC_TYPE_ANNOTATIONS[federallyInsured];
};
/**
 * Gets the name of the entity as the alt text for the associated image
 *
 * @param     {Object} marketplaceEntity  The marketplace entity
 * @return    {string}                    Alt text
 */


exports.getFederallyInsuredAnnotation = getFederallyInsuredAnnotation;

var getImageAltText = function getImageAltText(marketplaceEntity) {
  return getProductName(marketplaceEntity);
};
/**
 * Gets source URL of the image associated with the offer.
 *
 * @param      {Object}  marketplaceEntity  The banking entity
 *
 * @return     {string}                     The URL of the image.
 */


exports.getImageAltText = getImageAltText;

var getImageSrc = function getImageSrc(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.logo_url.value');
};
/**
 * Get the issuer.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} Issuer name.
 */


exports.getImageSrc = getImageSrc;

var getIssuerName = function getIssuerName(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.display_name.value');
};
/**
 * Gets url to review.
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {String}                   url
 */


exports.getIssuerName = getIssuerName;

var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.nw_review_url.value');
};
/**
 * Get the ingested, legacy banking institution type.
 * @deprecated - Use the `getInstitutionType` selector instead.
 *
 * @param {Object} marketplaceEntity - The marketplace entity.
 * @returns {String} - The legacy, bank institution type.
 */


exports.getLearnMoreLink = getLearnMoreLink;

var getLegacyInstitutionType = function getLegacyInstitutionType(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.type.value');
};
/**
 * Get the canonical, banking institution type.
 * Currently the legacy banking field is more reliably accurate so grab both and warn of mismatch.
 * @see {@link https://nerdwallet.slack.com/archives/CFUL4319S/p1597877978230300?thread_ts=1597874030.229700&cid=CFUL4319S}
 */


exports.getLegacyInstitutionType = getLegacyInstitutionType;

var getInstitutionType = function getInstitutionType(marketplaceEntity) {
  var legacyType = getLegacyInstitutionType(marketplaceEntity);
  var convertedType = _constants.LEGACY_TO_CANONICAL_INSTITUTION_TYPES[legacyType];
  var canonicalType = (0, _generalUtils.getCanonicalInstitutionType)(marketplaceEntity);

  if (convertedType !== canonicalType) {
    logger.warn("getInstitutionType() mismatch: `institution.type` \"".concat(canonicalType, "\" and `institution.details.type` \"").concat(legacyType, "\" -> \"").concat(convertedType, "\" "));
  }

  return convertedType || canonicalType;
};
/**
 * Gets required minimum balance.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {number}                     The required minimum balance.
 */


exports.getInstitutionType = getInstitutionType;

var getMinimumBalance = function getMinimumBalance(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.minimum_balance.value');
};
/**
 * Gets monthly fee.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {number}                     The monthly fee.
 */


exports.getMinimumBalance = getMinimumBalance;

var getMonthlyFee = function getMonthlyFee(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.fee_monthly.value');
};
/**
 * Gets name to display for an offer.
 * @note banking client shows generic name derived from sub-product type based on
 * simple heuristic if name is non-semantic
 *  https://github.com/NerdWallet/banking-client/blob/4423d3790f67e8f61f68a889a51079a753c40a24/client/components/results/results-utils.js#L87-L100
 *  https://github.com/NerdWallet/banking-client/blob/ac7ec2a2de9280d11aa8b69cf9e98554c9912414/client/lib/reducers/map-offers.js#L14-L20
 * @deprecated since 1.66.0 - Use "getProductName" directly.
 *
 * @param {Object} marketplaceEntity - The banking entity.
 * @return {String} - The offer name.
 */


exports.getMonthlyFee = getMonthlyFee;
var getName = withDeprecationWarning(function (marketplaceEntity) {
  var _callSelectorBySubPro;

  var issuerName = getIssuerName(marketplaceEntity);
  var productName = getProductName(marketplaceEntity);
  return (0, _generalUtils.callSelectorBySubProductType)(marketplaceEntity, (_callSelectorBySubPro = {}, (0, _defineProperty2.default)(_callSelectorBySubPro, _constants.BANKING_SUB_PRODUCT_TYPES.CHECKING, function () {
    return "".concat(issuerName, " ").concat(productName);
  }), (0, _defineProperty2.default)(_callSelectorBySubPro, _constants.BANKING_SUB_PRODUCT_TYPES.SAVINGS, function () {
    return "".concat(issuerName, " ").concat(productName);
  }), (0, _defineProperty2.default)(_callSelectorBySubPro, _constants.BANKING_SUB_PRODUCT_TYPES.CASH_MANAGEMENT, function () {
    return productName;
  }), (0, _defineProperty2.default)(_callSelectorBySubPro, _constants.BANKING_SUB_PRODUCT_TYPES.MONEY_MARKET, function () {
    return productName;
  }), (0, _defineProperty2.default)(_callSelectorBySubPro, _constants.BANKING_SUB_PRODUCT_TYPES.CD, function () {
    return "".concat(issuerName, " CD");
  }), _callSelectorBySubPro), (0, _defineProperty2.default)({}, _constants.PRODUCT_TYPES.BANKING, getSubProductType)) || issuerName;
}, {
  name: 'getName',
  migration: 'Use "banking/getProductName" directly.',
  version: '1.66.0'
});
/**
 * Get the offer url.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {String}                     The offer url.
 */

exports.getName = getName;

var getOfferUrl = function getOfferUrl(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.offer_url.value');
};
/**
 * Gets out-of-network ATM fee.
 *
 * @param      {Object}  marketplaceEntity  The BNK entity.
 *
 * @return     {number}                     The out-of-network ATM fee.
 */


exports.getOfferUrl = getOfferUrl;

var getOutOfNetworkATMFee = function getOutOfNetworkATMFee(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.fee_atm.value');
};
/**
 * Get the product name.
 *
 * @param       {Object} marketplaceEntity The marketplace entity.
 *
 * @return      {string} Product name.
 */


exports.getOutOfNetworkATMFee = getOutOfNetworkATMFee;

var getProductName = function getProductName(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.display_name.value');
};
/**
 * Get the "pros" bullets for an offer.
 * @note expects augmentation via `banking-products` post type through
 * AdditionalDataSDK
 *
 * @param   {Object} marketplaceEntity  The BNK entity.
 * @return  {Array<Object>} - The "pros" Structured Content array
 */


exports.getProductName = getProductName;

var getProsBullets = function getProsBullets(marketplaceEntity) {
  return (0, _get2.default)((0, _utils.getAdditionalData)((0, _generalUtils.getProduct)(marketplaceEntity)), 'pros');
};
/**
 * Get the institution rating for "Bank experience".
 *
 * @param  {Object} marketplaceEntity  The BNK entity.
 *
 * @return {Number}                    The institution rating for "Bank experience".
 */


exports.getProsBullets = getProsBullets;

var getRatingBankExperience = function getRatingBankExperience(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.nw_rating_bank_experience.value');
};
/**
 * Get the institution rating.
 *
 * @param  {Object} marketplaceEntity  The BNK entity.
 *
 * @return {Number}                    The institution rating.
 */


exports.getRatingBankExperience = getRatingBankExperience;

var getRatingInstitution = function getRatingInstitution(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.nw_rating.value');
};
/**
 * Get the institution rating for "Overdraft fee".
 *
 * @param  {Object} marketplaceEntity  The BNK entity.
 *
 * @return {Number}                    The institution rating for "Overdraft fee".
 */


exports.getRatingInstitution = getRatingInstitution;

var getRatingOverdraftFee = function getRatingOverdraftFee(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.nw_rating_overdraft_fee.value');
};
/**
 * Get whether this offer could monetize.
 * It relies on offer.details.is_monetizing (which does not exist at the time of writing), and will fall back to offer.derived_details.is_monetizing (which does exist).
 * This derived detail field (offer.derived_details.is_monetizing) is not consumed automatically and must be explicitly requested.
 *
 * @param {Object} marketplaceEntity    The banking entity.
 *
 * @return {boolean}                    Whether the offer could monetize. Defaults to true.
 * @deprecated - opt for common#getMonetizable
 */


exports.getRatingOverdraftFee = getRatingOverdraftFee;

var couldMonetize = function couldMonetize(marketplaceEntity) {
  var isMonetizing = (0, _get2.default)(marketplaceEntity, 'details.is_monetizing.value');
  return (0, _isNil2.default)(isMonetizing) ? true : isMonetizing;
};
/**
 * Get whether this offer should monetize.
 * This derived detail field (offer.derived_details.should_throttle_monetization) is not consumed automatically and must be explicitly requested.
 *
 * @param {Object} marketplaceEntity    The banking entity.
 *
 * @return {boolean}                    Whether the offer should monetize. Defaults to true.
 * @deprecated - opt for common#getMonetizable
 */


exports.couldMonetize = couldMonetize;

var shouldMonetize = function shouldMonetize(marketplaceEntity) {
  var shouldThrottle = (0, _get2.default)(marketplaceEntity, 'derived_details.should_throttle_monetization.value', false);
  return !shouldThrottle;
};
/**
 * Get this offer's monetization status as a string ('yes_assumed' | 'no' | 'no_because_of_limit' | 'no_because_of_lead').
 * This derived detail field (offer.derived_details.monetizable) is not consumed automatically and must be explicitly requested.
 *
 * @param {Object} marketplaceEntity    The banking entity.
 *
 * @return {string}                    Whether the offer should monetize ('yes_assumed' | 'no' | 'no_because_of_limit' | 'no_because_of_lead'). Defaults to 'yes_assumed'.
 * @deprecated - opt for common#getMonetizable, all banking offers with ID return a value
 */


exports.shouldMonetize = shouldMonetize;

var getMonetizationStatus = function getMonetizationStatus(marketplaceEntity) {
  var monetizationStatus = (0, _get2.default)(marketplaceEntity, 'derived_details.monetizable.value');
  return (0, _isNil2.default)(monetizationStatus) ? _constants.MONETIZATION_STATUSES.YES_ASSUMED : monetizationStatus;
};
/**
 * Get whether this offer is monetizing.
 * @note - This function is kept for backwards compatibility. It has been succeded by `shouldMonetize` and `couldMonetize` which provide improved clarity.
 * @note - Fallback to deprecated field set by banking-products service.
 * This derived detail field is not consumed automatically and must be explicitly requested.
 *
 * @param {Object} marketplaceEntity    The banking entity.
 *
 * @return {boolean}                    Whether the offer is monetizing.
 */


exports.getMonetizationStatus = getMonetizationStatus;
var getIsMonetizing = shouldMonetize;
/**
 * Get slug.
 *
 * @param {Object} marketplaceEntity The banking entity.
 *
 * @return {string} The slug.
 */

exports.getIsMonetizing = getIsMonetizing;

var getSlug = function getSlug(marketplaceEntity) {
  var institutionName = getIssuerName(marketplaceEntity);
  var productName = (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.display_name.value');
  return "".concat(institutionName, "-").concat(productName);
};
/**
 * Gets star rating.
 * @note - fallback to deprecated review rating set by banking-products service
 * or the institution rating (same path).
 *
 * @param      {Object}  marketplaceEntity  The banking entity.
 *
 * @return     {number}                     The star rating.
 */


exports.getSlug = getSlug;

var getStarRating = function getStarRating(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.rating_stars.value') || getRatingInstitution(marketplaceEntity);
};
/**
 * Gets star rating tooltip.
 *
 * @return     {string}                     The star rating tooltip.
 */


exports.getStarRating = getStarRating;

var getStarRatingTooltip = function getStarRatingTooltip() {
  return "NerdWallet's ratings are determined by our editorial team. The scoring formulas take into account multiple data points for each financial product and service.";
};
/**
 * Get sub product type.
 *
 * @param {Object} marketplaceEntity The BNK entity.
 *
 * @return {number} The sub product type.
 */


exports.getStarRatingTooltip = getStarRatingTooltip;

var getSubProductType = function getSubProductType(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.sub_product_type.value');
};
/**
 * Get sub copy for the monthly fee
 *
 * @param {Object} marketplaceEntity The BNK offer entity.
 *
 * @return {String|null} The sub copy for the monthly fee.ß
 */


exports.getSubProductType = getSubProductType;

var getMonthlyFeeSubCopy = function getMonthlyFeeSubCopy(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.fee_monthly_sub_copy.value');
};
/**
 * Get minimum opening deposit
 *
 * @param {Object} marketplaceEntity The BNK offer entity.
 *
 * @return {number|null} The minimum opening deposit value.
 */


exports.getMonthlyFeeSubCopy = getMonthlyFeeSubCopy;

var getMinimumOpeningDeposit = function getMinimumOpeningDeposit(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.min_opening_deposit.value');
};
/**
 * Get Product Audience.
 *
 * @param {Object} marketplaceEntity The BNK entity.
 *
 * @return {String} The product audience.
 */


exports.getMinimumOpeningDeposit = getMinimumOpeningDeposit;

var getProductAudience = function getProductAudience(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.product_audience.value');
};

exports.getProductAudience = getProductAudience;